(function () {
  'use strict';

  var ranges = [
    { size: 14, min: 23.0, max: 26.9 },
    { size: 15, min: 27.0, max: 28.99 },
    { size: 16, min: 29.0, max: 30.9 },
    { size: 17, min: 31.0, max: 32.6 },
    { size: 18, min: 32.7, max: 33.9 },
    { size: 19, min: 34.0, max: 36.0 }
  ];

  function recommendSize(diameter) {
    if (diameter < 23 || diameter > 36) return null;
    for (var i = 0; i < ranges.length; i++) {
      var range = ranges[i];
      if (diameter >= range.min && diameter <= range.max) return range;
    }
    return null;
  }

  function normalizeSizeValue(value) {
    var match = String(value || '').match(/(?:^|\D)(14|15|16|17|18|19)(?:\D|$)/);
    return match ? parseInt(match[1], 10) : null;
  }

  function readNumber(input) {
    var raw = String(input.value || '').replace(',', '.').trim();
    return raw === '' ? NaN : Number(raw);
  }

  function createChangeEvent() {
    if (typeof Event === 'function') return new Event('change', { bubbles: true });
    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    return event;
  }

  function selectProductSize(calculator, size) {
    var form = calculator.closest ? calculator.closest('form') : null;
    if (!form) {
      var parent = calculator.parentNode;
      while (parent && parent !== document) {
        if (parent.tagName === 'FORM') { form = parent; break; }
        parent = parent.parentNode;
      }
    }
    if (!form) return false;

    var position = calculator.getAttribute('data-size-option-position');
    if (!position || position === '0') return false;
    var selectors = form.querySelectorAll('.product-form__single-selector[data-option-position="' + position + '"]');

    for (var i = 0; i < selectors.length; i++) {
      var selector = selectors[i];
      if (selector.tagName === 'SELECT') {
        for (var j = 0; j < selector.options.length; j++) {
          if (normalizeSizeValue(selector.options[j].value) === size) {
            selector.value = selector.options[j].value;
            selector.dispatchEvent(createChangeEvent());
            if (selector.scrollIntoView) selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return true;
          }
        }
      } else if (normalizeSizeValue(selector.value) === size) {
        selector.checked = true;
        selector.dispatchEvent(createChangeEvent());
        if (selector.scrollIntoView) selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }
    }
    return false;
  }

  function initCalculator(calculator) {
    if (!calculator || calculator.getAttribute('data-initialized') === 'true') return;

    var widthInput = calculator.querySelector('[data-tire-width]');
    var ratioInput = calculator.querySelector('[data-aspect-ratio]');
    var rimInput = calculator.querySelector('[data-rim-size]');
    var calculateButton = calculator.querySelector('[data-calculate-tire-size]');
    var message = calculator.querySelector('[data-tire-message]');
    var result = calculator.querySelector('[data-tire-result]');
    var summaryOutput = calculator.querySelector('[data-tire-summary]');
    var fitNote = calculator.querySelector('[data-fit-note]');
    var selectButton = calculator.querySelector('[data-select-cover-size]');

    if (!widthInput || !ratioInput || !rimInput || !calculateButton || !message || !result || !summaryOutput || !fitNote) return;
    calculator.setAttribute('data-initialized', 'true');
    var recommendedSize = null;

    function showMessage(text, isError) {
      message.textContent = text || '';
      if (isError) message.classList.add('tire-calculator__message--error');
      else message.classList.remove('tire-calculator__message--error');
    }

    function hideResult() {
      showMessage('', false);
      result.hidden = true;
      result.style.display = 'none';
      if (selectButton) selectButton.hidden = true;
    }

    function calculate() {
      var width = readNumber(widthInput);
      var ratio = readNumber(ratioInput);
      var rim = readNumber(rimInput);

      hideResult();

      if (!isFinite(width) || !isFinite(ratio) || !isFinite(rim) || width < 100 || width > 500 || ratio < 20 || ratio > 100 || rim < 8 || rim > 30) {
        showMessage('Please enter all three numbers, for example 255 / 70 R18.', true);
        return;
      }

      var diameter = rim + (2 * (width * (ratio / 100) / 25.4));
      var recommendation = recommendSize(diameter);
      result.hidden = false;
      result.style.display = 'block';

      if (!recommendation) {
        recommendedSize = null;
        if (diameter > 36) {
          summaryOutput.textContent = 'Your tire diameter is ' + diameter.toFixed(2) + ' inches -> tire cover size is larger than 19 inch';
          fitNote.innerHTML = '<strong>Notes:</strong> Larger sizes are available. Please email us your request.';
        } else {
          summaryOutput.textContent = 'Your tire diameter is ' + diameter.toFixed(2) + ' inches -> please contact us';
          fitNote.innerHTML = '<strong>Notes:</strong> Please measure your spare tire and email us your request.';
        }
        return;
      }

      recommendedSize = recommendation.size;
      summaryOutput.textContent = 'Your tire diameter is ' + diameter.toFixed(2) + ' inches -> tire cover size is ' + recommendation.size + ' inch';
      fitNote.innerHTML = '<strong>Notes:</strong> Always measure the full outside diameter of your spare tire before ordering. Tire dimensions can vary slightly by manufacturer and tread.';
      if (selectButton) {
        selectButton.textContent = 'Select ' + recommendation.size + ' inch';
        selectButton.hidden = false;
      }
    }

    calculateButton.onclick = calculate;
    var inputs = [widthInput, ratioInput, rimInput];
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].oninput = hideResult;
      inputs[i].onkeydown = function (event) {
        event = event || window.event;
        if (event.key === 'Enter' || event.keyCode === 13) {
          if (event.preventDefault) event.preventDefault();
          calculate();
          return false;
        }
      };
    }

    if (selectButton) {
      selectButton.onclick = function () {
        if (!recommendedSize) return;
        if (selectProductSize(calculator, recommendedSize)) showMessage(recommendedSize + ' inch selected.', false);
        else showMessage('Choose ' + recommendedSize + ' inch from the size options above.', true);
      };
    }
  }

  function initAll() {
    var calculators = document.querySelectorAll('[data-tire-calculator]');
    for (var i = 0; i < calculators.length; i++) initCalculator(calculators[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
  setTimeout(initAll, 500);
  setTimeout(initAll, 1500);
}());
